<template>
	<div
		class="modal fade"
		ref="modelElementRef"
		tabindex="-1"
		role="dialog"
		:id="modalId"
		:data-backdrop="backdrop"
		:data-keyboard="keyboard"
	>
		<div class="modal-dialog modal-dialog-centered" style="max-width: fit-content">
			<div class="modal-content tw-rounded-2xl">
				<slot v-if="isOpen"></slot>
			</div>
		</div>
	</div>
</template>

<script setup>
import { getCurrentInstance, onMounted, ref, watch } from 'vue';

const props = defineProps({
	modelValue: {
		type: Boolean,
		default: false,
	},
	backdrop: {
		type: [Boolean, String],
		default: true,
	},
	keyboard: {
		type: Boolean,
		default: true,
	},
});

const isOpen = ref(false);
const modelElementRef = ref(null);

const emit = defineEmits(['update:modelValue', 'close', 'open']);

const vm = getCurrentInstance();
const modalId = `id-${vm.uid}`;

function open() {
	isOpen.value = true;
	const options = {
		backdrop: props.backdrop,
		keyboard: props.keyboard,
	};
	$(`#${modalId}`).modal(options);
	$(`#${modalId}`).modal('show');
}

const close = () => {
	isOpen.value = false;
	$(`#${modalId}`).modal('hide');
};

onMounted(() => {
	isOpen.value = props.modelValue;
	const modalElement = modelElementRef.value;
	if (!modalElement) {
		return;
	}
	modalElement.addEventListener('hidden.bs.modal', () => {
		isOpen.value = false;
		emit('close');
	});
	modalElement.addEventListener('shown.bs.modal', emit('open'));

   if (props.modelValue) {
		open();
	}
});

watch(isOpen, () => {
	emit('update:modelValue', isOpen.value);
});
watch(
	() => props.modelValue,
	(val) => {
		if (val) {
			open();
		} else {
			close();
		}
	},
);

defineExpose({
	open,
	close,
});
</script>

<style lang="scss" scoped>
@import 'tailwindcss/base';
@import 'tailwindcss/utilities';
</style>
